import type { NoticeListItem } from '../../../api/board';

/**
 * 공지 한 줄을 «끝난 것»으로 볼 것인가 — 흐리게 그릴지의 유일한 판정 (2026-09-16).
 *
 * 서버는 `isRead` · `confirmedAt` · `requiresConfirm` 을 **이미 보내고 있었다**. 웹이 타입에서
 * 버리고 있었을 뿐이다. 그 셋을 받아 왔으니, 이제 **무엇을 「끝났다」로 볼지**를 정해야 한다.
 *
 * ★★★ **읽은 것과 확인한 것은 다르다.** 「확인」까지 받아야 하는 공지(`requiresConfirm`)는
 *     열어 보기만 해서는 **아직 할 일이 남아 있다.** 그것을 `isRead` 만 보고 흐리게 그리면
 *     화면이 「끝났다」고 말하는데 실제로는 안 끝난 것이 된다 — **화면이 거짓말하는 쪽**이다.
 *     그래서 확인이 필요한 공지는 **`confirmedAt` 이 찍혔을 때만** 끝난 것으로 본다.
 *
 * ★★ **모르면 흐리게 하지 않는다.** 옛 서버는 이 칸들을 안 보낸다(`undefined`). 그때
 *     「읽었다」로 넘겨짚으면 **새 공지가 읽은 것처럼 묻힌다.** 못 본 것을 못 봤다고 두는 쪽이,
 *     본 것을 안 봤다고 두는 쪽보다 훨씬 덜 해롭다.
 */
export function noticeDone(n: Pick<NoticeListItem, 'isRead' | 'confirmedAt' | 'requiresConfirm'>): boolean {
  if (n.requiresConfirm === true) return n.confirmedAt != null;
  return n.isRead === true;
}
